/* global angular, moment */

(function () {
  'use strict';
  
  angular
    .module('vcutils.doctor')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcutilsdoctor', {
        url: '/vcutilsdoctor',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;doctorsearch doctor="" doctorref="" editinplace="true"&gt;</tt></h3><div ui-view="doctorsearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;doctorsearch doctor="" doctorref="" parentsave=""&gt;</tt></h3><div ui-view="doctorsearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;doctoreditor doctor="" mode="" onClose=""&gt;</tt></h3><div ui-view="doctoreditview"></div>
              <h3 class="alert alert-info"><tt>&lt;doctornew&gt;</tt></h3><div ui-view="doctornewview"></div>
              <h3 class="alert alert-info"><tt>&lt;doctorlist doctors="?"&gt;</tt></h3><div ui-view="doctorlistview"></div>
            `
          }
        },
        onEnter: ['$log', function ($log) {
          $log.debug('debug/routes - playground.vcutilsdoctor entered');
        }]
      });
    
    
    $stateProvider
      .state('playground.vcutilsdoctor.allcomponents', {
        url: '/allcomponents',
        resolve: {
          doctor: function () {
            return '';
          },
          doctorref: function () {
            return '';
          },
          somedoctor: ['Doctor', function (Doctor) {
            return Doctor.$find('570a73678dd4bd20cb031193');
          }],
          alldoctors: ['Doctor', function (Doctor) {
            return Doctor.$search({active: true});
          }],
          parentsavesearch: function () {
            return function (doctor, doctorref) {
              console.log('debug: dummy parentsave called for doctorsearch with: ', doctor, doctorref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'doctorsearchview@playground.vcutilsdoctor': {
            component: 'doctorsearch',
            bindings: {
              doctor: 'doctor',
              doctorref: 'doctorref',
              editinplace: 'eip'
            }
          },
          'doctorsearchview2@playground.vcutilsdoctor': {
            component: 'doctorsearch',
            bindings: {
              doctor: 'doctor',
              doctorref: 'doctorref',
              parentsave: 'parentsavesearch'
            }
          },
          'doctoreditview@playground.vcutilsdoctor': {
            component: 'doctoreditor',
            bindings: {
              doctor: 'somedoctor'
            }
          },
          'doctornewview@playground.vcutilsdoctor': {
            component: 'doctornew',
            bindings: {
            }
          },
          'doctorlistview@playground.vcutilsdoctor': {
            component: 'doctorlist',
            bindings: {
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcutilsdoctor.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






